export const QUERY_PAYER = "QUERY_PAYER";
export const QUERY_PAYER_LIST = "QUERY_PAYER_LIST";
export const QUERY_ALL_PAYER_LIST = "QUERY_ALL_PAYER_LIST";
